/* Phone buy bar for product pages (snippets/product-sticky-bar.liquid).
   Shows whenever the main Add to cart button is off screen on a phone; its button
   clicks the real submit button so Dawn's product form and cart drawer do the work. */
(function () {
  const bar = document.querySelector('[data-product-sticky-bar]');
  if (!bar) return;
  const main = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!main || !('IntersectionObserver' in window)) return;

  const phone = () => window.innerWidth < 750;
  let mainVisible = true;
  const update = () => { bar.hidden = mainVisible || !phone(); };

  new IntersectionObserver((entries) => {
    mainVisible = entries[0].isIntersecting;
    update();
  }, { threshold: 0 }).observe(main);

  window.addEventListener('resize', update);
  bar.querySelector('[data-sticky-add]').addEventListener('click', () => {
    if (main.disabled) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    main.click();
  });
})();
